import { darkColors } from "@hl/base-components/lib/theme/dark/colors";
import { darkTheme } from "@hl/base-components/lib/theme/dark/theme";
import { lightColors } from "@hl/base-components/lib/theme/light/colors";
import {
  createLightTheme,
  lightTheme,
} from "@hl/base-components/lib/theme/light/theme";
import { CoreCustomColors } from "@hl/base-components/lib/theme/type";
import { EmbedTheme } from "@hl/shared-features/lib/features/mint/types";
import { MantineThemeOverride, Tuple } from "@mantine/core";
import Color from "color";

import { EmbedFlags } from "./customize";

const toLightenArray = (baseColor: Color, step = 8): Tuple<string, 10> => {
  const colors = [];
  for (let i = 1; i < 10; i++) {
    const color = baseColor
      .alpha(i / step)
      .rgb()
      .string();
    colors.push(color);
  }
  colors.push(baseColor.hex());
  return colors as Tuple<string, 10>;
};

export const generateMantineTheme = (
  embedTheme: EmbedTheme,
  flags: EmbedFlags
): MantineThemeOverride => {
  const { bgColor, textColor, fontFamily, accentColor } = embedTheme;

  if (!bgColor && fontFamily) {
    const theme = flags.enableDarkMode ? darkTheme : lightTheme;
    setThemeFont(theme, fontFamily);
    return theme;
  }
  // if no enough colors, use default theme
  if (!bgColor || !textColor) {
    return flags.enableDarkMode ? darkTheme : lightTheme;
  }

  const bg = Color(bgColor);
  const text = Color(textColor);
  const accent = accentColor ? Color(accentColor) : bg;

  const isLightTheme = bg.luminosity() > text.luminosity();

  let colors: CoreCustomColors;

  if (isLightTheme) {
    colors = {
      ...lightColors,
      black: toLightenArray(text),
      gray: toLightenArray(accent),
      white: toLightenArray(bg),
    };
  } else {
    colors = {
      ...darkColors,
      black: toLightenArray(text),
      gray: toLightenArray(accent),
      white: toLightenArray(bg),
    };
  }
  const theme = createLightTheme(colors);
  if (fontFamily) {
    setThemeFont(theme, fontFamily);
  }
  function setThemeFont(theme: MantineThemeOverride, fontFamily: string) {
    theme.fontFamily = fontFamily;
    if (theme.headings) {
      theme.headings.fontFamily = fontFamily;
    }
  }

  return theme;
};
